/* =====================================================================
   WAVEFORM — slide-out cart drawer
   Real Shopify cart: add/remove go through the Cart AJAX API and the
   drawer re-renders itself server-side via the Section Rendering API,
   so prices, discounts and the free-gift progress are always Liquid-
   rendered truth — no client-side cart state.

   Public API (window.WaveformCart): .open() / .close() / .refresh()
   Wire-ups (delegated, work for late-rendered content):
     - any [data-cart-open] or header cart icon opens the drawer
     - any form[action*="/cart/add"] submits via AJAX then opens it
     - [data-quick-add="<variant-id>"] buttons quick-add one unit
     - [data-cart-remove="<line-key>"] removes a line
   ===================================================================== */
(function () {
  'use strict';
  if (window.WaveformCart) return;

  var SECTION_ID = 'cart-drawer';
  var drawer = null, scrim = null, liveRegion = null, lastFocused = null;

  function els() {
    drawer = document.getElementById('CartDrawer');
    scrim = document.getElementById('CartScrim');
    liveRegion = document.getElementById('CartLiveRegion');
    return drawer && scrim;
  }

  /* ---- focus trap ---- */
  function trapTab(e) {
    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('open')) return;
    var f = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (!els()) return;
    lastFocused = document.activeElement;
    scrim.classList.add('open');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', trapTab);
    var c = drawer.querySelector('[data-cart-close]');
    if (c) setTimeout(function () { c.focus(); }, 30);
  }

  function close() {
    if (!els()) return;
    scrim.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', trapTab);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }

  /* ---- server-side re-render via the Section Rendering API ---- */
  function replaceFromHtml(html) {
    if (!els()) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawer');
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    drawer.dataset.itemCount = fresh.dataset.itemCount || '0';
    syncBadges(parseInt(drawer.dataset.itemCount, 10) || 0);
    loadUpsell();
    announceCart();
  }

  /* ---- SR announcement of the freshly-rendered subtotal (WCAG 4.1.3) ---- */
  function announceCart() {
    if (!liveRegion) return;
    var count = parseInt(drawer.dataset.itemCount, 10) || 0;
    var S = window.WaveformStrings || {};
    var msg;
    if (count <= 0) {
      msg = S.cart_emptied || 'Your cart is empty.';
    } else {
      /* Subtotal is the first .cd-foot .cd-line's value — Liquid-rendered, currency-formatted. */
      var sub = drawer.querySelector('.cd-foot .cd-line .v');
      var subtotal = sub ? sub.textContent.trim() : '';
      var tmpl = S.cart_updated || 'Cart updated. Subtotal [subtotal].';
      msg = subtotal ? tmpl.replace('[subtotal]', subtotal) : 'Cart updated.';
    }
    /* Clear then set on next tick so identical repeat messages are still announced. */
    liveRegion.textContent = '';
    setTimeout(function () { if (liveRegion) liveRegion.textContent = msg; }, 60);
  }

  /* ---- "pairs well with" rail: complementary recommendations for the
     newest cart item, excluding anything already in the cart ---- */
  function loadUpsell() {
    var box = drawer && drawer.querySelector('[data-drawer-upsell]');
    if (!box) return;
    var inCart = Array.prototype.map.call(drawer.querySelectorAll('[data-product-id]'), function (el) {
      return parseInt(el.dataset.productId, 10);
    });
    if (!inCart.length) { box.hidden = true; return; }
    var base = box.dataset.recsUrl || '/recommendations/products';
    if (base.indexOf('.json') < 0) base += '.json'; /* routes.product_recommendations_url is extension-less */
    var currency = box.dataset.currency || 'USD';

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: currency,
          minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) { return '$' + (cents / 100); }
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function fetchRecs(intent) {
      var url = base + (base.indexOf('?') < 0 ? '?' : '&') + 'product_id=' + inCart[0] + '&limit=6&intent=' + intent;
      return fetch(url).then(function (r) { return r.ok ? r.json() : { products: [] }; });
    }
    fetchRecs('complementary')
      .then(function (d) {
        var list = (d.products || []).filter(function (p) { return inCart.indexOf(p.id) < 0; });
        if (list.length) return list;
        return fetchRecs('related').then(function (d2) {
          return (d2.products || []).filter(function (p) { return inCart.indexOf(p.id) < 0; });
        });
      })
      .then(function (list) {
        list = list.slice(0, 3);
        var rail = box.querySelector('[data-upsell-rail]');
        if (!list.length || !rail) { box.hidden = true; return; }
        rail.innerHTML = list.map(function (p) {
          var imgUrl = p.featured_image
            ? p.featured_image + (String(p.featured_image).indexOf('?') < 0 ? '?' : '&') + 'width=256'
            : '';
          var img = imgUrl ? '<img src="' + esc(imgUrl) + '" alt="" loading="lazy" onerror="this.style.display=\'none\'">' : '';
          var oneVariant = p.variants && p.variants.length === 1 && p.variants[0].available;
          var action = oneVariant
            ? '<button class="btn btn-secondary btn-sm" type="button" data-quick-add="' + p.variants[0].id + '">+</button>'
            : '<a class="btn btn-secondary btn-sm" href="' + esc(p.url) + '">→</a>';
          return '<div class="cu-item">'
            + '<a class="cu-thumb" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>'
            + '<div class="cu-meta"><a class="cu-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
            + '<span class="cu-price">' + money(p.price) + '</span></div>'
            + action
            + '</div>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; });
  }

  function syncBadges(n) {
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.hidden = n <= 0;
    });
  }

  function refresh() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=' + SECTION_ID : '/?sections=' + SECTION_ID)
      .then(function (r) { return r.json(); })
      .then(function (sections) { replaceFromHtml(sections[SECTION_ID]); })
      .catch(function () {});
  }

  function busy(on) { if (drawer) drawer.setAttribute('aria-busy', on ? 'true' : 'false'); }

  function showError(msg) {
    if (!drawer) return;
    var region = drawer.querySelector('[data-cart-errors]');
    if (region) { region.textContent = msg; region.hidden = false; setTimeout(function () { region.hidden = true; }, 5000); }
  }

  /* ---- mutations ---- */
  function alreadyInCart(variantId) {
    if (!variantId) return Promise.resolve(false);
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart.items || []).some(function (i) { return i.id === variantId; }); })
      .catch(function () { return false; });
  }

  function addFromForm(form, trigger) {
    var fd = new FormData(form);
    var limitOne = !!(window.WaveformStrings && window.WaveformStrings.limit_one);
    fd.append('sections', SECTION_ID);
    fd.append('sections_url', window.location.pathname);
    busy(true);
    var precheck = limitOne ? alreadyInCart(parseInt(fd.get('id'), 10)) : Promise.resolve(false);
    return precheck.then(function (already) {
      if (already) {
        return refresh().then(function () {
          open();
          showError((window.WaveformStrings && window.WaveformStrings.already_in_cart) || 'Already in your cart');
        }).finally(function () { busy(false); });
      }
      if (limitOne) fd.set('quantity', '1');
      return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) { showError(data.description || data.message || 'Could not add to cart.'); open(); return; }
          if (data.sections && data.sections[SECTION_ID]) replaceFromHtml(data.sections[SECTION_ID]);
          else return refresh();
        })
        .then(function () {
          if (trigger && window.WaveformAdded) window.WaveformAdded(trigger);
          setTimeout(open, 150);
          document.dispatchEvent(new CustomEvent('waveform:cart:changed'));
        })
        .finally(function () { busy(false); });
    });
  }

  function addVariant(variantId, trigger) {
    var form = document.createElement('form');
    var id = document.createElement('input');
    id.name = 'id'; id.value = variantId;
    var qty = document.createElement('input');
    qty.name = 'quantity'; qty.value = '1';
    form.appendChild(id); form.appendChild(qty);
    return addFromForm(form, trigger);
  }

  function changeLine(key, quantity) {
    busy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION_ID, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections[SECTION_ID]) replaceFromHtml(data.sections[SECTION_ID]);
        document.dispatchEvent(new CustomEvent('waveform:cart:changed'));
      })
      .catch(function () { showError((window.WaveformStrings && window.WaveformStrings.cart_error) || 'Could not update your cart.'); })
      .finally(function () { busy(false); });
  }

  /* ---- delegated wiring ---- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); open(); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }

    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.cartRemove, 0); return; }

    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault(); e.stopPropagation();
      if (qa.dataset.soldOut === 'true') return;
      if (window.WaveformBump) window.WaveformBump(qa);
      addVariant(qa.dataset.quickAdd, qa);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.dataset.ajaxCart === 'false') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    addFromForm(form, btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) close();
  });

  function wireScrim() { if (els()) { scrim.addEventListener('click', close); loadUpsell(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireScrim);
  else wireScrim();

  /* re-render after the theme editor reloads the drawer section */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#CartDrawer')) wireScrim();
  });

  window.WaveformCart = { open: open, close: close, refresh: refresh, notice: showError };
})();
